"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ERROR_TEXTS = void 0;
exports.DEFAULT_ERROR_TEXTS = {
    gtEndDateError: 'The date greater end date',
    ltStartDateError: 'The date less than start date',
    parseError: 'The date is invalid',
    defaultError: 'The date is invalid'
};
//# sourceMappingURL=constants.js.map